const navLinkStyledFPC = {
  text: 'Go back to home page to enter'
};

export default navLinkStyledFPC;
